export const Types = {
  GET_DEFECT_REQUEST: 'GET_DEFECT_REQUEST',
  GET_DEFECT_SUCCESS: 'GET_DEFECT_SUCCESS',
  SET_DEFECT_ERROR: 'SET_DEFECT_ERROR',
  SET_SELECTION: 'SET_SELECTION',
  SET_DEFECT_FILTER_KEY: 'SET_DEFECT_FILTER_KEY',
  SET_CURRENT_DEFECT: 'SET_CURRENT_DEFECT',
  RESET_DEFECTS: 'RESET_DEFECTS',
  ADD_DEFECTS: 'ADD_DEFECTS',
  CHANGE_FILTER: 'CHANGE_FILTER'
};

export const getDefectRequest = (
  kulModelKodu,
  garantiTipi,
  WorkOrderDetails
) => ({
  type: Types.GET_DEFECT_REQUEST,
  kulModelKodu,
  garantiTipi,
  WorkOrderDetails
});

export const resetDefects = () => {
  localStorage.setItem("UpdateButtonDefectControl", 0);
  return {
    type: Types.RESET_DEFECTS
  }
};

export const getDefectSuccess = (response, selectedDefects) => {
  localStorage.setItem("UpdateButtonDefectControl", 1);
  return {
    type: Types.GET_DEFECT_SUCCESS,
    payload: response,
    selectedDefects
  }
};

export const changeFilter = () => ({
  type: Types.CHANGE_FILTER
});

export const addDefects = defects => ({
  type: Types.ADD_DEFECTS,
  payload: { defects }
});



export const setDefectError = error => ({
  type: Types.SET_DEFECT_ERROR,
  payload: { error }
});

export const setSelection = item => {
  return {
    type: Types.SET_SELECTION,
    payload: { item }
  };
};

export const setDefectFilterKey = (
  filterKey,
  level1Selection,
  level2Selection
) => {
  return {
    type: Types.SET_DEFECT_FILTER_KEY,
    payload: {
      filterKey,
      level1Selection: level1Selection || 0,
      level2Selection: level2Selection || 0
    }
  };
};

export const setCurrentDefect = value => {
  return {
    type: Types.SET_CURRENT_DEFECT,
    payload: { value }
  };
};
